export default __webpack_public_path__ + "static/media/master-8.bad56f19.png";